import React, { useState } from 'react';
import { login, forgotPassword, confirmForgotPassword, resendConfirmationOTP } from '../apiService'; // Import the login function
import { useNavigate } from 'react-router-dom'; // For navigation after login
import '../App.css'; // Import your CSS styles

const LoginModal = ({ handleClose }) => {
  const [username, setUsername] = useState(''); // This will accept either email or mobile number
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showForgotPassword, setShowForgotPassword] = useState(false); // State to toggle Forgot Password modal
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);

  const [loading, setLoading] = useState(true);

  const [showConfirmForgot, setShowConfirmForgot] = useState(false);
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [showLoginModal, setShowLoginModal] = useState(true);


  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmError, setConfirmError] = useState('');
  const [confirmSuccess, setConfirmSuccess] = useState('');

  // Countdown state for resend OTP
  const [resendCountdown, setResendCountdown] = useState(0);

  // Countdown effect
  React.useEffect(() => {
    let timer;
    if (resendCountdown > 0) {
      timer = setTimeout(() => setResendCountdown(resendCountdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [resendCountdown]);

  const handleLogin = async (event) => {
    event.preventDefault();
    setError(""); // Clear previous errors
  
    try {
      const result = await login(username, password, navigate);
  
      console.log("Backend response:", result); // Log the response to debug
  
      if (result.success) {
        console.log("Login successful:", result);
        handleClose();
        window.location.reload(); // Refresh to update navbar
      } else {
        console.error("Login failed:", result.detail || result.message);
        setError(result.detail || "An error occurred. Please try again."); // Set backend error message
      }
    } catch (error) {
      console.error("Unexpected error during login:", error);
      setError("An unexpected error occurred. Please try again.");
    }
  };


  const handleForgotPasswordSubmit = async (event) => {
    event.preventDefault();
    setError(""); // clear previous errors

    // ⬇️  Front‑end validation: user must supply something
    if (!email && !phoneNumber) {
      setError("Please enter your email or phone number.");
      return;
    }

    try {
      const result = await forgotPassword(email, phoneNumber);

      if (result.success) {
        // success: switch to OTP screen
        setShowForgotPassword(false);
        setShowConfirmForgot(true);
        setResendCountdown(60); // Start 60s countdown after OTP sent
      } else {
        setError(result.message); // backend‑supplied message
      }
    } catch (err) {
      console.error("Forgot‑password error:", err);
      setError("An unexpected error occurred. Please try again.");
    }
  };


  const handleConfirmForgotPassword = async (e) => {
    e.preventDefault();
    setConfirmError('');
    setConfirmSuccess('');

    if (newPassword !== confirmNewPassword) {
      setConfirmError("New password and confirmation do not match.");
      return;
    }

    try {
      const result = await confirmForgotPassword({
        email,
        mobileNumber: phoneNumber,
        otp,
        newPassword,
      });

      if (result.success) {
        setConfirmSuccess('Password reset successfully. You can now log in.');
        setTimeout(() => {
          setShowConfirmForgot(false);
          window.location.reload(); // 🔥 This reloads the page so LoginModal resets
        }, 3000);
      } else {
        setConfirmError(result.message);
      }
    } catch (error) {
      console.error("Reset error:", error);
      setConfirmError("An error occurred. Please try again.");
    }
  };



  const handleResendOTP = async () => {
    setConfirmError('');
    setConfirmSuccess('');

    if (!email && !phoneNumber) {
      setConfirmError("Please enter your email or phone number first.");
      return;
    }

    try {
      const result = await forgotPassword(email, phoneNumber); // reuse same function

      if (result.success) {
        setConfirmSuccess('OTP resent successfully.');
        setResendCountdown(60); // Restart 60s countdown after resend
      } else {
        setConfirmError(result.message);
      }
    } catch (err) {
      setConfirmError("Failed to resend OTP. Please try again.");
    }
  };


  return (
    <>
      {/* Login Modal */}
      {showLoginModal && (
        <div className="modal show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="loginModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header text-white"
                  style={{
                    backgroundColor: '#e2520f', // Custom primary color
                    color: 'var(--white)', // Custom text color
                  }}
              >
                <h5 className="modal-title" id="loginModalLabel">Login</h5>
                <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
              </div>
              <div className="modal-body text-dark"
                    // style={{
                    //   backgroundColor: '#111434f2', // Custom primary color
                    //   color: 'var(--white)', // Custom text color
                    // }}
              >
                <form onSubmit={handleLogin}>
                <div className="mb-3">
                  <label htmlFor="username" className="form-label">Email or Mobile Number</label>
                  <input 
                    type="text" 
                    className="form-control" 
                    id="username" 
                    value={username} 
                    onChange={(e) => setUsername(e.target.value)} 
                    onFocus={(e) => {
                      e.target.style.borderColor = '#e56521'; // Set border color to orange
                      e.target.style.outline = '2px solid #e56521'; // Set outline to orange
                    }} 
                    onBlur={(e) => {
                      e.target.style.borderColor = '#ccc'; // Reset border color to default
                      e.target.style.outline = 'none'; // Remove outline
                    }} 
                    required
                    style={{
                      borderColor: '#ccc', // Default border color
                      boxShadow: 'none',
                      outline: 'none', // Default outline
                      transition: 'border-color 0.1s ease, outline 0.1s ease', // Smooth transition for border and outline
                    }}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">Password</label>
                  <div className="input-group">
                    <input 
                      type={showPassword ? "text" : "password"} // Toggle between text and password
                      className="form-control" 
                      id="password" 
                      value={password} 
                      onChange={(e) => setPassword(e.target.value)} 
                      onFocus={(e) => {
                        e.target.style.borderColor = '#e56521'; // Set border color to orange
                        e.target.style.outline = '2px solid #e56521'; // Set outline to orange
                      }} 
                      onBlur={(e) => {
                        e.target.style.borderColor = '#ccc'; // Reset border color to default
                        e.target.style.outline = 'none'; // Remove outline
                      }} 
                      required
                      style={{
                        borderColor: '#ccc', // Default border color
                        boxShadow: 'none',
                        outline: 'none', // Default outline
                        transition: 'border-color 0.1s ease, outline 0.1s ease', // Smooth transition for border and outline
                      }}
                    />
                    <button 
                      type="button" 
                      className="btn btn-secondary" 
                      onClick={() => setShowPassword(!showPassword)} // Toggle password visibility
                    >
                      {showPassword ? (
                        <i className="bi bi-eye-slash"></i> // Eye-slash icon for hidden password
                      ) : (
                        <i className="bi bi-eye"></i> // Eye icon for visible password
                      )}
                    </button>
                  </div>
                </div>

                  {error && <div className="alert alert-danger">{error}</div>}
                  <button type="submit" className="ftthsa btn-secondary">Login</button>
                </form>
                <div className="mt-2 text-left">
                  <button 
                    type="button" 
                    className="btn btn-link" 
                    onClick={() => {
                      setShowLoginModal(false);
                      setShowForgotPassword(true);
                    }}
                  >
                    Forgot Password?
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Forgot Password Modal */}
      {showForgotPassword && (
        <div className="modal show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="forgotPasswordModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header text-white"
                  style={{
                    backgroundColor: '#e2520f', // Custom primary color
                    color: 'var(--white)', // Custom text color
                  }}
              >
                <h5 className="modal-title" id="forgotPasswordModalLabel">Forgot Password</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowForgotPassword(false);
                    window.location.reload();
                  }}
                  aria-label="Close"
                ></button>

              </div>
              <div className="modal-body text-dark"
              
                    // style={{
                    //   backgroundColor: '#111434f2', // Custom primary color
                    //   color: 'var(--white)', // Custom text color
                    // }}
                >
                <form onSubmit={handleForgotPasswordSubmit}>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Enter Registered Email</label>
                    <input 
                      type="email" 
                      className="form-control" 
                      id="email" 
                      value={email} 
                      onChange={(e) => setEmail(e.target.value)} 
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="phoneNumber" className="form-label">Enter Registered Phone Number</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      id="phoneNumber" 
                      value={phoneNumber} 
                      onChange={(e) => setPhoneNumber(e.target.value)} 
                      
                    />
                  </div>
                  {error && <div className="alert alert-danger">{error}</div>}
                  <button type="submit" className="ftthsa btn-secondary">Submit</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}


      {showConfirmForgot && (
        <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header text-white" style={{ backgroundColor: '#e2520f' }}>
                <h5 className="modal-title">Confirm Password Reset</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowConfirmForgot(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-dark">
                <form onSubmit={handleConfirmForgotPassword}>
                  <div className="mb-3">
                    <label className="form-label">OTP</label>
                    <input
                      type="text"
                      className="form-control"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      required
                      minLength={4}
                      maxLength={4}
                    />
                  </div>

                  {/* New Password Field with Eye Icon */}
                  <div className="mb-3">
                    <label className="form-label">New Password</label>
                    <div className="input-group">
                      <input
                        type={showNewPassword ? 'text' : 'password'}
                        className="form-control"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                        minLength={6}
                        maxLength={20}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setShowNewPassword(!showNewPassword)}
                        tabIndex={-1}
                        style={{
                          backgroundColor: '#6c757d',
                          borderColor: '#6c757d',
                          color: 'white',
                          borderTopLeftRadius: 0,
                          borderBottomLeftRadius: 0,
                        }}
                      >
                        <i className={`bi ${showNewPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                      </button>
                    </div>
                  </div>

                  {/* Confirm New Password Field with Eye Icon */}
                  <div className="mb-3">
                    <label className="form-label">Confirm New Password</label>
                    <div className="input-group">
                      <input
                        type={showConfirmNewPassword ? 'text' : 'password'}
                        className="form-control"
                        value={confirmNewPassword}
                        onChange={(e) => setConfirmNewPassword(e.target.value)}
                        required
                        minLength={6}
                        maxLength={20}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)}
                        tabIndex={-1}
                        style={{
                          backgroundColor: '#6c757d',
                          borderColor: '#6c757d',
                          color: 'white',
                          borderTopLeftRadius: 0,
                          borderBottomLeftRadius: 0,
                        }}
                      >
                        <i className={`bi ${showConfirmNewPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                      </button>
                    </div>
                  </div>

                  {confirmError && <div className="alert alert-danger">{confirmError}</div>}
                  {confirmSuccess && <div className="alert alert-success">{confirmSuccess}</div>}

                  <div className="d-flex justify-content-between align-items-center">

                    <button
                      type="button"
                      className="ftthsa btn-secondary"
                      onClick={handleResendOTP}
                      disabled={resendCountdown > 0}
                      style={
                        resendCountdown > 0
                          ? {
                              backgroundColor: '#ffd9c2', // Weak orange
                              borderColor: '#ffd9c2',
                              color: '#e2520f',
                              cursor: 'not-allowed',
                              opacity: 1
                            }
                          : {}
                      }
                    >
                      {resendCountdown > 0 ? `Resend OTP (${resendCountdown}s)` : 'Resend OTP'}
                    </button>

                    <button type="submit" className="ftthsa btn-secondary">
                      Reset Password
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}


    </>
  );
};

export default LoginModal;
